import React, { createContext, useContext, useEffect, useMemo } from 'react';

export const THEME_STORAGE_KEY = 'flashcode_theme_preference';
export const THEME_PREFERENCES = Object.freeze(['dark']);

const ThemeContext = createContext(undefined);

export function applyResolvedTheme() {
  const root = document.documentElement;
  root.dataset.theme = 'dark';
  root.style.colorScheme = 'dark';

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', '#0f0f13');
  }
}

export function ThemeProvider({ children }) {
  useEffect(() => {
    applyResolvedTheme();

    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, 'dark');
    } catch {
      // Ignore storage write errors
    }
  }, []);

  const value = useMemo(
    () => ({
      preference: 'dark',
      resolvedTheme: 'dark',
      setPreference: () => {},
      isLight: false,
      isDark: true,
    }),
    []
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
